import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { LoaderService, LoadingModule } from '@tmhcc-ng-lib/framwork/loader';
import { FeatureProductComponent } from './feature-product/feature-product.component';
import { CustomModalComponent } from './custom-modal/custom-modal.component';
import { TestFormModule } from './test-form/test-form.module';
import { SupportRequestModule } from './support-request/support-request.module';
import { AgencyRequestModule } from './agency-request/agency-request.module';
import { CoverageInfoModule } from './coverage-info/coverage-info.module';
import { UnderwritingInfoModule } from './underwriting-info/underwriting-info.module';
import { BindInfoModule } from './bind-info/bind-info.module';
import { PageStepNavModule } from './shared/page-step-nav/page-step-nav.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
// import { GeneralInfoTabsComponent } from './general-info-tabs/general-info-tabs.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppDataService } from '@tmhcc-ng-lib/data-service';
import { ThankYouModule } from './thank-you/thank-you.module';
import { FarmersThankYouModule } from './farmers-thank-you/farmers-thank-you.module';
import { NewsFeedModule } from './news-feed/news-feed.module';
import { ContactModelComponent } from './contact-model/contact-model.component';
import { PipesModule } from '@tmhcc-ng-lib/framwork/pipes';
import { SignApplicationComponent } from './sign-application/sign-application.component';
import { ContactUsModule } from './contact-us/contact-us.module';
import { CustomLoginComponent } from './custom-login/custom-login.component';
import { PopupModalComponent } from './popup-modal/popup-modal.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    DashboardModule,
    CoverageInfoModule,
    UnderwritingInfoModule,
    BindInfoModule,
    LoadingModule,
    SupportRequestModule,
    AgencyRequestModule,
    ThankYouModule,
    FarmersThankYouModule,
    PageStepNavModule,
    TestFormModule,
    CommonModule,
    NewsFeedModule,
    ContactUsModule,
    PipesModule
  ],
  providers: [LoaderService, AppDataService],
  exports: [
    FeatureProductComponent,
    CustomModalComponent,
    ForgetPasswordComponent,
    ContactModelComponent,
    PipesModule
  ],
  declarations: [
    FeatureProductComponent,
    CustomModalComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    ContactModelComponent,
    SignApplicationComponent,
    CustomLoginComponent,
    PopupModalComponent
  ]
})
export class ArtisanEdgeModule {}
